<template>
  <div class="about-lime">
    <v-card color="white" width="100%" flat tile>
      <v-container class="py-10">
        <v-row>
          <!-- Privacy Policy -->
          <v-col cols="12">
            <h3 class="heading-h3 mb-2 policy-blue">Privacy Policy</h3>
            <h6 class="heading-h6 policy-blue">
              <strong>Century Financial Services (PTY) LTD</strong>
            </h6>
            <h6 class="heading-h6 policy-blue">
              <strong>Company Registration Number: </strong>2023/140135/07
            </h6>
            <h6 class="heading-h6 policy-blue">
              <strong>NCR Registration Number: </strong>NCRCP20790
            </h6>
            <hr class="my-4" />
          </v-col>

          <v-col cols="12">
            <!-- 1. INTRODUCTION -->
            <h4 class="heading-h4 mb-4 policy-blue">1. INTRODUCTION</h4>
            <p
              v-for="(paragraph, index) in paragraphsForSection1"
              :key="'s1-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- 2. WEBSITE CONSENT AND ACCEPTANCE -->
            <h4 class="heading-h4 mb-4 policy-blue">
              2. WEBSITE CONSENT AND ACCEPTANCE
            </h4>
            <p
              v-for="(paragraph, index) in paragraphsForSection2"
              :key="'s2-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>
            <DefaultList
              :listItems="bulletsForSection2"
              class="mt-2 mb-n6 ml-4"
            />
            <p class="b-body-1">{{ paragraphsForSection2Footer.text }}</p>

            <!-- 3. PERSONAL INFORMATION COLLECTED -->
            <h4 class="heading-h4 mb-4 policy-blue">
              3. PERSONAL INFORMATION COLLECTED
            </h4>
            <p class="b-body-1">{{ paragraphsForSection3[0].text }}</p>
            <DefaultList
              :listItems="bulletsForSection3"
              class="mt-2 mb-n6 ml-4"
            />

            <!-- 4. PURPOSES OF PROCESSING -->
            <h4 class="heading-h4 mb-4 policy-blue">
              4. PURPOSES OF PROCESSING
            </h4>
            <p class="b-body-1">{{ paragraphsForSection4[0].text }}</p>
            <DefaultList
              :listItems="bulletsForSection4"
              class="mt-2 mb-n6 ml-4"
            />

            <!-- 5. NATIONAL CREDIT ACT COMPLIANCE -->
            <h4 class="heading-h4 mb-4 policy-blue">
              5. NATIONAL CREDIT ACT COMPLIANCE
            </h4>
            <p class="b-body-1">{{ paragraphsForSection5[0].text }}</p>
            <p class="b-body-1">{{ paragraphsForSection5[1].text }}</p>
            <DefaultList
              :listItems="bulletsForSection5"
              class="mt-2 mb-n6 ml-4"
            />

            <!-- 6. AFFORDABILITY ASSESSMENTS -->
            <h4 class="heading-h4 mb-4 policy-blue">
              6. AFFORDABILITY ASSESSMENTS – NCA REGULATION 23A
            </h4>
            <p class="b-body-1">{{ paragraphsForSection6[0].text }}</p>
            <p class="b-body-1">{{ paragraphsForSection6[1].text }}</p>
            <DefaultList
              :listItems="bulletsForSection6"
              class="mt-2 mb-n6 ml-4"
            />
            <p class="b-body-1">{{ paragraphsForSection6[2].text }}</p>

            <!-- 7. AUTOMATED DECISION-MAKING AND CREDIT SCORING -->
            <h4 class="heading-h4 mb-4 policy-blue">
              7. AUTOMATED DECISION-MAKING AND CREDIT SCORING
            </h4>
            <p class="b-body-1">{{ paragraphsForSection7[0].text }}</p>
            <p class="b-body-1">{{ paragraphsForSection7[1].text }}</p>
            <DefaultList
              :listItems="bulletsForSection7"
              class="mt-2 mb-n6 ml-4"
            />
            <p class="b-body-1">{{ paragraphsForSection7[2].text }}</p>

            <!-- 8. CREDIT BUREAU REPORTING AND DISPUTES -->
            <h4 class="heading-h4 mb-4 policy-blue">
              8. CREDIT BUREAU REPORTING AND DISPUTES
            </h4>
            <p
              v-for="(paragraph, index) in paragraphsForSection8"
              :key="'s8-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>
            <DefaultList
              :listItems="bulletsForSection8"
              class="mt-2 mb-n6 ml-4"
            />
            <p class="b-body-1">{{ paragraphsForSection8Footer.text }}</p>

            <!-- 9. SACRRA DATA SHARING -->
            <h4 class="heading-h4 mb-4 policy-blue">9. SACRRA DATA SHARING</h4>
            <p class="b-body-1">{{ paragraphsForSection9[0].text }}</p>
            <p class="b-body-1">{{ paragraphsForSection9[1].text }}</p>
            <DefaultList
              :listItems="bulletsForSection9"
              class="mt-2 mb-n6 ml-4"
            />
            <p class="b-body-1">{{ paragraphsForSection9[2].text }}</p>

            <!-- 10. MARKETING COMMUNICATION -->
            <h4 class="heading-h4 mb-4 policy-blue">
              10. MARKETING COMMUNICATION
            </h4>
            <p
              v-for="(paragraph, index) in paragraphsForSection10"
              :key="'s10-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- 11. DISCLOSURE TO THIRD PARTIES -->
            <h4 class="heading-h4 mb-4 policy-blue">
              11. DISCLOSURE TO THIRD PARTIES
            </h4>
            <p class="b-body-1">{{ paragraphsForSection11[0].text }}</p>
            <DefaultList
              :listItems="bulletsForSection11"
              class="mt-2 mb-n6 ml-4"
            />
            <p class="b-body-1">{{ paragraphsForSection11[1].text }}</p>

            <!-- 12. REFERRALS FOLLOWING DECLINED APPLICATIONS -->
            <h4 class="heading-h4 mb-4 policy-blue">
              12. REFERRALS FOLLOWING DECLINED APPLICATIONS
            </h4>
            <p class="b-body-1">{{ paragraphsForSection12[0].text }}</p>
            <DefaultList
              :listItems="bulletsForSection12"
              class="mt-2 mb-n6 ml-4"
            />
            <p class="b-body-1">{{ paragraphsForSection12[1].text }}</p>

            <!-- 13. DATA SECURITY -->
            <h4 class="heading-h4 mb-4 policy-blue">13. DATA SECURITY</h4>
            <p class="b-body-1">{{ paragraphsForSection13[0].text }}</p>
            <DefaultList
              :listItems="bulletsForSection13"
              class="mt-2 mb-n6 ml-4"
            />

            <!-- 14. DATA BREACH MANAGEMENT -->
            <h4 class="heading-h4 mb-4 policy-blue">
              14. DATA BREACH MANAGEMENT
            </h4>
            <p
              v-for="(paragraph, index) in paragraphsForSection14"
              :key="'s14-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- 15. PAIA MANUAL AND ACCESS TO INFORMATION -->
            <h4 class="heading-h4 mb-4 policy-blue">
              15. PAIA MANUAL AND ACCESS TO INFORMATION
            </h4>
            <p
              v-for="(paragraph, index) in paragraphsForSection15"
              :key="'s15-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- 16. DATA RETENTION SCHEDULE -->
            <h4 class="heading-h4 mb-4 policy-blue">
              16. DATA RETENTION SCHEDULE
            </h4>
            <p class="b-body-1">{{ paragraphsForSection16[0].text }}</p>
            <v-simple-table class="retention-table mb-6">
              <thead>
                <tr>
                  <th>Record Type</th>
                  <th>Purpose</th>
                  <th>Retention Period</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, index) in retentionSchedule"
                  :key="'ret-' + index"
                >
                  <td>{{ row.type }}</td>
                  <td>{{ row.purpose }}</td>
                  <td>{{ row.period }}</td>
                </tr>
              </tbody>
            </v-simple-table>

            <!-- 17. THIRD PARTY WEBSITES -->
            <h4 class="heading-h4 mb-4 policy-blue">
              17. THIRD PARTY WEBSITES
            </h4>
            <p
              v-for="(paragraph, index) in paragraphsForSection17"
              :key="'s17-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- 18. AGE RESTRICTION -->
            <h4 class="heading-h4 mb-4 policy-blue">18. AGE RESTRICTION</h4>
            <p
              v-for="(paragraph, index) in paragraphsForSection18"
              :key="'s18-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- 19. CUSTOMER RIGHTS -->
            <h4 class="heading-h4 mb-4 policy-blue">19. CUSTOMER RIGHTS</h4>
            <p
              v-for="(paragraph, index) in paragraphsForSection19"
              :key="'s19-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- 20. POPIA INFORMATION OFFICER -->
            <h4 class="heading-h4 mb-4 policy-blue">
              20. POPIA INFORMATION OFFICER
            </h4>
            <p
              v-for="(paragraph, index) in paragraphsForSection20"
              :key="'s20-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- 21. CHANGES TO THIS POLICY -->
            <h4 class="heading-h4 mb-4 policy-blue">
              21. CHANGES TO THIS POLICY
            </h4>
            <p
              v-for="(paragraph, index) in paragraphsForSection21"
              :key="'s21-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>

            <!-- 22. GOVERNING LAW -->
            <h4 class="heading-h4 mb-4 policy-blue">22. GOVERNING LAW</h4>
            <p
              v-for="(paragraph, index) in paragraphsForSection22"
              :key="'s22-' + index"
              v-html="paragraph.text"
              class="b-body-1"
            ></p>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import DefaultList from "@/components/shared/lists/DefaultList";

export default {
  name: "LimeLoansPrivacyPolicy",

  components: { DefaultList },

  data() {
    return {
      // Section 1 - Introduction
      paragraphsForSection1: [
        {
          text: `This Privacy Policy explains how Century Financial Services (PTY) LTD ("Century FS") collects, processes, stores, uses and protects personal information in accordance with the Protection of Personal Information Act No. 4 of 2013 ("POPIA"), the National Credit Act 34 of 2005 ("NCA"), the Electronic Communications and Transactions Act, and other applicable South African legislation.`,
        },
        {
          text: `This Policy applies to all customers, applicants, website users and any person whose personal information is processed by Century FS.`,
        },
        {
          text: `This Policy must be read together with the Century FS Loan Agreement, Website Terms and Conditions, and any related documentation provided during the loan application process.`,
        },
      ],

      // Section 2 - Website Consent and Acceptance
      paragraphsForSection2: [
        {
          text: `During the loan application process customers must confirm acceptance of this Privacy Policy by selecting a confirmation tick box.`,
        },
        {
          text: `By selecting the tick box the customer:`,
        },
      ],
      bulletsForSection2: [
        {
          text: `confirms that they have read and understood this Privacy Policy;`,
        },
        {
          text: `consents to the collection, processing and storage of their personal information;`,
        },
        {
          text: `authorises Century FS to verify information through credit bureaus and other lawful sources;`,
        },
        {
          text: `consents to the sharing of information with authorised service providers where necessary.`,
        },
      ],
      paragraphsForSection2Footer: {
        text: `This electronic confirmation constitutes explicit consent in terms of POPIA and forms part of the application record retained by Century FS.`,
      },

      // Section 3 - Personal Information Collected
      paragraphsForSection3: [
        { text: `Century FS may collect personal information including:` },
      ],
      bulletsForSection3: [
        { text: `full name and surname` },
        { text: `identity number or passport number` },
        { text: `contact details` },
        { text: `residential information` },
        { text: `employment and income information` },
        { text: `banking details` },
        { text: `credit history and financial information` },
        { text: `loan application and transaction data` },
        { text: `digital device or interaction data related to website use` },
      ],

      // Section 4 - Purposes of Processing
      paragraphsForSection4: [
        {
          text: `Century FS processes personal information for purposes including:`,
        },
      ],
      bulletsForSection4: [
        { text: `verifying identity` },
        { text: `performing affordability and creditworthiness assessments` },
        { text: `providing credit services` },
        { text: `managing loan accounts` },
        { text: `complying with legal and regulatory obligations` },
        { text: `detecting fraud or financial crime` },
        { text: `improving products and services` },
        {
          text: `assisting customers with financial rehabilitation where appropriate`,
        },
      ],

      // Section 5 - NCA Compliance
      paragraphsForSection5: [
        {
          text: `Century FS is a registered credit provider and processes personal information in accordance with the National Credit Act.`,
        },
        { text: `Information may be used to:` },
      ],
      bulletsForSection5: [
        { text: `perform affordability assessments` },
        { text: `verify employment and income` },
        { text: `obtain credit bureau reports` },
        { text: `report repayment performance to credit bureaus` },
        { text: `comply with National Credit Regulator obligations` },
      ],

      // Section 6 - Affordability Assessments
      paragraphsForSection6: [
        {
          text: `Century FS conducts affordability assessments in accordance with Section 81 of the National Credit Act and Regulation 23A.`,
        },
        {
          text: `To perform these assessments Century FS may process personal information relating to:`,
        },
        {
          text: `This information is used to determine whether a customer has the financial means to meet the proposed credit obligations without becoming over-indebted, as required by the National Credit Act.`,
        },
      ],
      bulletsForSection6: [
        { text: `income and employment verification` },
        { text: `declared living expenses` },
        { text: `existing credit obligations` },
        { text: `credit bureau records` },
        {
          text: `bank account transaction history where authorised by the customer`,
        },
      ],

      // Section 7 - Automated Decision-Making
      paragraphsForSection7: [
        {
          text: `Century FS may use automated decision-making systems, credit scoring models and risk assessment tools to evaluate loan applications.`,
        },
        { text: `These systems analyse information including:` },
        {
          text: `Automated systems assist Century FS in making consistent and objective credit risk assessments while complying with the National Credit Act.`,
        },
      ],
      bulletsForSection7: [
        { text: `credit bureau data` },
        { text: `repayment history` },
        { text: `affordability information` },
        { text: `application behaviour patterns` },
      ],

      // Section 8 - Credit Bureau Reporting
      paragraphsForSection8: [
        {
          text: `Century FS reports credit agreement information and repayment performance to registered credit bureaus as required by the National Credit Act.`,
        },
        {
          text: `Customers have the right to dispute inaccurate credit bureau information.`,
        },
        {
          text: `Where a customer believes credit bureau information is incorrect the customer may:`,
        },
      ],
      bulletsForSection8: [
        { text: `lodge a dispute with the relevant credit bureau; or` },
        {
          text: `contact Century FS to request assistance with correcting inaccurate information.`,
        },
      ],
      paragraphsForSection8Footer: {
        text: `Credit bureaus must investigate disputes within regulatory timeframes and correct inaccurate information where appropriate.`,
      },

      // Section 9 - SACRRA Data Sharing
      paragraphsForSection9: [
        {
          text: `Century FS participates in industry data sharing initiatives administered through the South African Credit and Risk Reporting Association (SACRRA).`,
        },
        {
          text: `Through SACRRA frameworks, credit providers may share certain anonymised or aggregated credit performance data for purposes including:`,
        },
        {
          text: `Such data sharing is conducted in accordance with POPIA and applicable industry governance standards.`,
        },
      ],
      bulletsForSection9: [
        { text: `fraud prevention` },
        { text: `improving credit risk assessment models` },
        { text: `industry risk monitoring` },
        { text: `responsible lending practices` },
      ],

      // Section 10 - Marketing Communication
      paragraphsForSection10: [
        {
          text: `By accepting this Privacy Policy customers "opt-in" to receive marketing communications via SMS, email, or phone. Customers may at any time opt-out by using the "opt-out" or "unsubscribe" options in email and SMS's communication. Customers may at any time opt-out by using the "opt-out" register managed by the Direct Marketing Association of South Africa (DMASA) at <a href="https://dmasa.org/" class="text-decoration-none font-weight-medium" target="_blank">www.dmasa.org</a>.`,
        },
      ],

      // Section 11 - Disclosure to Third Parties
      paragraphsForSection11: [
        {
          text: `Century FS may disclose personal information to authorised service providers including:`,
        },
        {
          text: `All service providers are contractually required to comply with POPIA and maintain confidentiality.`,
        },
      ],
      bulletsForSection11: [
        { text: `registered credit bureaus` },
        { text: `payment processors` },
        { text: `technology providers` },
        { text: `debt collection agencies` },
        { text: `fraud prevention providers` },
        { text: `regulatory authorities` },
      ],

      // Section 12 - Referrals Following Declined Applications
      paragraphsForSection12: [
        {
          text: `If a loan application is declined Century FS may refer customers to authorised third-party financial service providers who offer:`,
        },
        {
          text: `By accepting this Privacy Policy customers consent to the sharing of limited personal information for these purposes.`,
        },
      ],
      bulletsForSection12: [
        { text: `financial rehabilitation services` },
        { text: `credit profile improvement services` },
        { text: `debt counselling` },
        { text: `budgeting assistance` },
        { text: `alternative regulated financial products` },
      ],

      // Section 13 - Data Security
      paragraphsForSection13: [
        {
          text: `Century FS maintains appropriate technical and organisational security safeguards including:`,
        },
      ],
      bulletsForSection13: [
        { text: `encrypted databases` },
        { text: `secure network infrastructure` },
        { text: `intrusion detection systems` },
        { text: `role-based access control` },
        { text: `staff confidentiality agreements` },
      ],

      // Section 14 - Data Breach Management
      paragraphsForSection14: [
        {
          text: `If a security breach occurs affecting personal information, Century FS will investigate the incident, take remedial action and notify the Information Regulator and affected individuals where required by law.`,
        },
      ],

      // Section 15 - PAIA Manual
      paragraphsForSection15: [
        {
          text: `Century FS maintains a Promotion of Access to Information Act (PAIA) Manual in accordance with Section 51 of PAIA.`,
        },
        {
          text: `The PAIA Manual explains how members of the public may request access to records held by Century FS, including records containing personal information.`,
        },
        {
          text: `The PAIA Manual is available on the Century FS website or may be requested directly from the company.`,
        },
      ],

      // Section 16 - Data Retention Schedule
      paragraphsForSection16: [
        {
          text: `Century FS retains records in accordance with regulatory and operational requirements. Typical retention periods include:`,
        },
      ],
      retentionSchedule: [
        {
          type: `Loan agreements`,
          purpose: `NCA regulatory compliance`,
          period: `Minimum 3–5 years after settlement`,
        },
        {
          type: `Affordability assessments`,
          purpose: `NCR audit verification`,
          period: `Minimum 3–5 years`,
        },
        {
          type: `Customer identification documents`,
          purpose: `Legal verification`,
          period: `Minimum 5 years`,
        },
        {
          type: `Transaction records`,
          purpose: `Accounting and regulatory reporting`,
          period: `Minimum 5 years`,
        },
        {
          type: `Declined applications`,
          purpose: `Risk management and audit purposes`,
          period: `3 years or longer if required`,
        },
        {
          type: `Customer complaints`,
          purpose: `Complaint resolution and regulatory oversight`,
          period: `3–5 years`,
        },
      ],

      // Section 17 - Third Party Websites
      paragraphsForSection17: [
        {
          text: `Our website may contain links to external sites. Century FS accepts no responsibility for the privacy practices or content of third-party websites. We advise Customers to review the privacy policies of those websites before providing personal information.`,
        },
      ],

      // Section 18 - Age Restriction
      paragraphsForSection18: [
        {
          text: `Century FS does not provide credit services to individuals under the age of 18. Use of our website or services by minors is strictly prohibited.`,
        },
      ],

      // Section 19 - Customer Rights
      paragraphsForSection19: [
        {
          text: `Customers have the right to request access to their personal information, request correction of inaccurate information, object to certain processing activities and lodge complaints with the Information Regulator.`,
        },
      ],

      // Section 20 - POPIA Information Officer
      paragraphsForSection20: [
        {
          text: `Century FS has appointed an Information Officer responsible for POPIA compliance, data governance and responding to customer information requests. Contact details are available on the Century FS website.`,
        },
      ],

      // Section 21 - Changes to Policy
      paragraphsForSection21: [
        {
          text: `Century FS may update this Privacy Policy from time to time. The latest version will always be available on the company website. Continued use of our services indicates acceptance of any changes.`,
        },
      ],

      // Section 22 - Governing Law
      paragraphsForSection22: [
        {
          text: `This Privacy Policy is governed by the laws of the Republic of South Africa. Any disputes arising from this Policy shall be resolved in accordance with the jurisdiction of South African courts or by referral to the Credit Ombud.`,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.policy-blue {
  color: #1f4e79 !important;
}

.retention-table {
  border: 1px solid #1f4e79;
  border-radius: 4px;
  margin-top: 8px;

  th {
    background-color: #1f4e79 !important;
    color: white !important;
    font-weight: 600;
    padding: 12px 16px;
  }

  td {
    padding: 10px 16px;
    border-bottom: 1px solid #d0dce8;
    color: #1f4e79;
  }

  tr:last-child td {
    border-bottom: none;
  }

  tr:hover td {
    background-color: #eaf1fb !important;
  }
}
</style>
